import { getPage } from '@/services/content/content-service';

export { default } from '@/components/page/page';

export async function getStaticProps() {
  const data = await getPage('/');

  return { props: data };
}
